jQuery( document ).ready(function() {

// document.getElementsByClassName("cutom-row__image")[2].setAttribute("srcset", "");
// document.getElementsByClassName("cutom-row__image")[2].setAttribute("data-srcset", "");



// Newsletter display only when ste hasn't been visited


      $(".close").click(function() {
        $( ".newsletter" ).slideToggle( 1000, function() {
          // Animation complete.
        });
      });

      function GetCookie(name) {
        var arg=name+"=";
        var alen=arg.length;
        var clen=document.cookie.length;
        var i=0;

        while (i<clen) {
            var j=i+alen;
                if (document.cookie.substring(i,j)==arg)
                    return "here";
                i=document.cookie.indexOf(" ",i)+1;
                if (i==0)
                    break;
        }

        return null;
      }

      var visit=GetCookie("COOKIE1");

      if (visit==null){
        $( ".newsletter" ).delay( 5500 ).slideToggle( 2000, function() {
          // Animation complete.
        });
      }

      var expire=new Date();
      expire=new Date(expire.getTime()+7776000000);
      document.cookie="COOKIE1=here; expires="+expire;

});
